import { render, staticRenderFns } from "./yuyueDialog.vue?vue&type=template&id=10cc9a2d&scoped=true"
import script from "./yuyueDialog.vue?vue&type=script&lang=js"
export * from "./yuyueDialog.vue?vue&type=script&lang=js"
import style0 from "./yuyueDialog.vue?vue&type=style&index=0&id=10cc9a2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cc9a2d",
  null
  
)

export default component.exports